var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("user")]),_c('p',[_vm._v("欢迎回来,"+_vm._s(_vm.$route.params.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }